import { useDispatch } from 'react-redux';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import { HeartWithUsers } from 'entities/heart-with-users';
import { weddingActions } from 'entities/wedding';
import { COLOR_WHITE, uiSelector } from 'shared/config';
import { useShallowSelector } from 'shared/hooks';
import { checkRequestStatusEquality } from 'shared/utils';
import { useTranslation } from 'react-i18next';
import {useState} from "react";

type MatchUserProps = {
  avatar: string;
  firstName: string;
  lastName: string;
};

type MatchContainerProps = {
  femaleProps: MatchUserProps;
  manProps: MatchUserProps;
  partnerFullName: string;
  type?: 'simple' | 'simpleWithName' | 'connection';
};

export const MatchContainer = ({ femaleProps, manProps, partnerFullName, type = 'connection' }: MatchContainerProps) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const uiState = useShallowSelector(uiSelector.getUI);
    const [ActiveState, setActiveState] = useState<boolean>(false);

    let isStartEngagementLoading = checkRequestStatusEquality(uiState[weddingActions.startEngagement?.type]);

    const handleGetMarried = () => {
        setActiveState(true);
        dispatch(weddingActions.startEngagement());
    };

  return (
      <>

          <Stack sx={{alignItems: 'center'}}>
              <Typography variant="h3" sx={{
                  fontSize: '36px',
                  fontWeight: '700',
                  lineHeight: '0.95',
                  textAlign: 'center',
                  mt: { xs: 3, md: 0 },
                  fontFamily: 'Montserrat, sans-serif'
              }} className="center">{t('connection_fiance_engaged')}</Typography>
          </Stack>
    <Stack alignItems="center" mt={{ xs: 10, md: 14 }}>
      <HeartWithUsers femaleProps={femaleProps} manProps={manProps} size={'connection'} type={type} />
        {/*<Typography variant="h4" className="bold" mb={{ xs: 4, md: 8 }}>
        {partnerFullName}
      </Typography>*/}
      <Button variant="outlined" onClick={handleGetMarried} disabled={ActiveState} sx={{ width: 231, marginBottom: 10 }}>
        {ActiveState ? <CircularProgress size={30} sx={{ color: COLOR_WHITE }} /> : t('connection_fiance_engaged_button')}
      </Button>
        <Stack sx={{maxWidth: '400px', display: 'none', alignItems: 'center', justifyContent: 'center'}}>
            {ActiveState ? <Typography variant="h4" mb={{ xs: 4, md: 8 }} sx={{fontSixe: '16px'}}>{t('connection_activateState')}</Typography> : ''}
        </Stack>
      </Stack>
      </>
  );
}
